<template>
  <div class="map-box">
    <div id="container"></div>
    <Search ref="searchRef" @changeZoom="changeZoom" :city="city" />
    <HouseList />
    <Tools ref="toolsRef" />
  </div>
</template>

<script>
window._AMapSecurityConfig = {
  securityJsCode: '7c2c3f2292c44b6fe1432e8eea172185',
}
import AMapLoader from '@amap/amap-jsapi-loader'
import Search from './modules/search.vue'
import HouseList from './modules/houseList.vue'
import Tools from './modules/tools.vue'
export default {
  components: {
    Search,
    HouseList,
    Tools,
  },
  data() {
    return {
      city: {}, //城市信息
      cluster: null,
      // map:null
    }
  },
  mounted() {
    //DOM初始化完成进行地图初始化
    this.initMap()
  },
  methods: {
    initMap() {
      AMapLoader.load({
        key: 'dab7a5f8e233973eeef1e56933819fc8', // 申请好的Web端开发者Key，首次调用 load 时必填
        // securityJsCode:'7c2c3f2292c44b6fe1432e8eea172185',
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15,
        plugins: [
          'AMap.ToolBar',
          'AMap.ElasticMarker',
          'AMap.Scale',
          'AMap.HawkEye',
          'AMap.Geolocation',
          'AMap.CitySearch',
          'AMap.AdvancedInfoWindow',
          'AMap.AutoComplete',
          'AMap.PlaceSearch',
          'AMap.Geocoder',
          'AMap.MouseTool',
          'AMap.CircleEditor',
          'AMap.PolylineEditor',
          'AMap.MarkerCluster',
          'AMap.RangingTool',
          'AMap.HeatMap',
          'AMap.ControlBar',
        ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map('container', {
            //设置地图容器id
            viewMode: '3D', //是否为3D地图模式
            zoom: 13, //初始化地图级别
            // center: [104.073288, 30.665368], //初始化地图中心点位置  ,省略 定位到当前城市中心
          })
          this.getCityInfo(AMap)
          this.placeSearch(AMap, this.map)
          this.showControl(AMap, this.map)
          this.showScallTool(AMap, this.map)
          this.useRangingTool(AMap, this.map)
          this.useMarkersCluster(AMap, this.map)
        })
        .catch((e) => {
          console.log(e)
        })
    },
    // 获取城市信息
    getCityInfo(AMap) {
      let citySearch = new AMap.CitySearch()
      citySearch.getLocalCity((status, result) => {
        console.log(status, 'result', result)
        if (status === 'complete' && result.info === 'OK') {
          this.city = result
        }
      })
    },
    // poi搜索注册时间
    placeSearch(AMap, map) {
      this.$refs.searchRef.registerSearch(AMap, map)
    },

    showControl(AMap, map) {
      map.addControl(
        new AMap.ControlBar({
          position: {
            right: '20px',
            top: '20px',
          },
          showControlButton: true, // 是否显示倾斜、旋转按钮。默认为 true
        })
      )
    },
    // 缩放工具
    showScallTool(AMap, map) {
      map.addControl(new AMap.ToolBar())
    },
    // 使用距离测算工具
    useRangingTool(AMap, map) {
      this.$refs.toolsRef.registerRangingTool(AMap, map)
    },
    // 使用点聚合
    useMarkersCluster(AMap, map) {
      var gridSize = 60
      // 数据中需包含经纬度信息字段 lnglat
      var points = [
        { weight: 8, lnglat: ['104.073288', '30.665368'] },
        { weight: 7, lnglat: ['104.074288', '30.665368'] },
      ]
      for (let i = 0; i < 100; i++) {
        let random = Math.random()
        points.push({
          weight: 1,
          lnglat: ['104.06' + i, '30.64' + i],
        })
      }
      // console.log(points,'points')
      var count = points.length

      var _renderClusterMarker = (context) => {
        // console.log(context, '999context')
        var factor = Math.pow(context.count / count, 1 / 18)
        var div = document.createElement('div')
        // var Hue = 180 - factor * 180
        var Hue = 240
        var bgColor = 'hsla(' + Hue + ',100%,40%,0.7)'
        var fontColor = 'hsla(' + Hue + ',100%,90%,1)'
        var borderColor = 'hsla(' + Hue + ',100%,40%,1)'
        var shadowColor = 'hsla(' + Hue + ',100%,90%,1)'
        div.style.backgroundColor = bgColor
        var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20)
        // div.style.width = div.style.height = size + 'px'
        div.style.width = '60px'
        div.style.border = 'solid 1px ' + borderColor
        // div.style.borderRadius = size / 2 + 'px'
        div.style.borderRadius = '50%'
        div.style.boxShadow = '0 0 5px ' + shadowColor
        div.innerHTML = context.count + '套'
        // div.style.lineHeight = size + 'px'
        div.style.lineHeight = '60px'
        div.style.color = fontColor
        div.style.fontSize = '14px'
        div.style.textAlign = 'center'
        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2))
        context.marker.setContent(div)
      }
      var _renderMarker = function (context) {
        var content =
          '<div style="background-color: hsla(240 , 100%, 50%, 0.3); height: 18px; width: 18px; border: 1px solid hsl(240 , 100%, 40%); border-radius: 12px; box-shadow: hsl(240 , 100%, 50%) 0px 0px 3px;"></div>'
        var offset = new AMap.Pixel(-9, -9)
        context.marker.setContent(content)
        context.marker.setOffset(offset)
      }
      const addCluster = () => {
        if (this.cluster) {
          this.cluster.setMap(null)
        }
        this.cluster = new AMap.MarkerCluster(map, points, {
          gridSize: gridSize, // 设置网格像素大小
          // maxZoom:,
          renderClusterMarker: _renderClusterMarker, // 自定义聚合点样式
          renderMarker: _renderMarker, // 自定义非聚合点样式
        })

        this.cluster.on('click', (item) => this.clickMark(item))
      }

      addCluster()
    },
    // 条件改变
    changeZoom(arr) {
      this.cluster.addData(arr)
    },
    clickMark(item) {
      console.log(item,'000')
     //此处是通过包含点的数量判断是否是聚合点，不是聚合点就执行上方单个点的点击方式
          if (item.clusterData.length <= 1) {
            return
          }
          //这里是计算所有聚合点的中心点
          let alllng = 0,
            alllat = 0
          for (const mo of item.clusterData) {
            alllng += mo.lnglat.lng
            alllat += mo.lnglat.lat
          }
          const lat = alllat / item.clusterData.length
          const lng = alllng / item.clusterData.length
          //这里是放大地图，此处写死了每次点击放大的级别，可以根据点的数量和当前大小适应放大，体验更佳
          this.map.setZoomAndCenter(this.map.getZoom() + 6, [lng, lat])
    },
  },
}
</script>
<style scoped lang="less">
.map-box {
  height: calc(100vh - 190px);
  position: relative;
}
#container {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
/deep/ .amap-toolbar {
  box-shadow: none !important;
}
/deep/ .amap-toolbar span {
  width: 60px;
  height: 40px;
  color: rgba(15, 64, 245, 100) !important;
  font-size: 32px !important;
  // padding-bottom: 10px;
  // line-height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/deep/ .amap-toolbar span:first-child {
  border-bottom: none !important;
}
</style>
